'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './service-requests-list.routes';

export class ServiceRequestsListComponent {

  constructor(IntegrationService, Auth, dialogs, Config, $state, $uibModal) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.integrationAvailable = true;
    this.IntegrationService = IntegrationService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Service Requests");

    IntegrationService.test(result => {
      if (!result || !result.status || !result.status == 'successful') {
        this.integrationAvailable = false;
      } else {

        IntegrationService.queryServiceRequestsByUser({email: this.Auth.getCurrentUserSync().email}, data => {
          this.requests = data;
        });

      }
    })
  }

  cancel(request) {
    var that = this;

    var dlg = this.dialogs.confirm("Cancel Service Request?", "Do you really want to cancel the service request?" +
      "<br/><br/><b>" + request.code + "</b><br/>" + request.instructions);
    dlg.result.then(() => {
      that.IntegrationService.deleteServiceRequest({id: request._id},
        () => {
          that.requests = that.requests.filter(function( obj ) {
            return obj._id !== request._id;
          });
        },
        err => {
          alert("Could not cancel service request");
        });
    }, () => {
      // Cancel
    });
  }

  openServiceRequestInfoModal(ticket) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'serviceRequestInfoComponent',
      resolve: {
        config: function() {
          return {
            ticket
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.serviceRequests.list', [uiRouter])
  .config(routes)
  .component('serviceRequestsList', {
    template: require('./service-requests-list.html'),
    controller: ServiceRequestsListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/service-requests/list/service-requests-list.component.js